import { FC, ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {env} from "../config/env";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5분
        },
        mutations: {
            retry: 0,
        },
    },
});

interface QueryProviderProps {
    children: ReactNode;
}

export const QueryProvider: FC<QueryProviderProps> = ({ children }) => {
    const isDev = env.isDevelopment;

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {isDev && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    );
};
